import { useState } from 'react'
import { useAlert } from 'react-alert'

import alertImage from '../../assets/images/alert.gif'
import { useModalBox, useOnChangeDetect } from '../../contexts'
import { Button } from '..'
import { DeleteStyled } from './styles'
import { deleteAssessment } from '../../../main/usecases/services/assesment'

const DeleteAssessmentModal = ({ item }: any) => {
  const [loading, setLoading] = useState(false)
  const { modalClose } = useModalBox()
  const alert = useAlert()
  const { setRefresh } = useOnChangeDetect()

  const handleDeleteService = async (id: number) => {
    try {
      setLoading(true)
      await deleteAssessment({
        id: id
      }).delete()
      modalClose(true)
      alert.show('Avaliação Psicológica deletada com sucesso', {
        type: 'success',
        timeout: 4000
      })
      setRefresh((prev: any) => !prev)
    } catch (error) {
      modalClose(true)
      setRefresh((prev: any) => !prev)
      console.error(error)
      alert.show('Erro ao deletar uma avaliação psicológica', {
        type: 'error',
        timeout: 4000
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <DeleteStyled className="delete-modal">
      <img src={alertImage} />
      <div className="content">
        <p>
          Deseja realmente deletar a avaliação Psicologica? Essa ação não poderá
          ser revertida.
        </p>
        <div className="actions">
          <Button
            hasredButton
            onClick={() => handleDeleteService(item.cdAvaliacaoPsicologica)}
            disabled={loading}
          >
            Sim
          </Button>
          <Button hasSecodaryButton onClick={modalClose}>
            Não
          </Button>
        </div>
      </div>
    </DeleteStyled>
  )
}

export default DeleteAssessmentModal
